// import { useEffect, useState } from "react";
// import ProductCategoryTable from "./ProductCategoryTable";
// import ProductCategoryModal from "./ProductCategoryModal";
// import Modal from "components/common/Modal";
// import { useProductCategory } from "./hooks/useProductCategory";
// import { useOrganizers } from "components/company/hooks/useOrganizers";
// import Alert from "components/common/Alert";

// export default function ProductCategoryContainer() {
//   const {
//     data,
//     loading,
//     loadCategories,
//     addCategory,
//     editCategory,
//     deleteCategory,
//   } = useProductCategory();

//   const { companies } = useOrganizers();

//   const [editing, setEditing] = useState(null);
//   const [openAdd, setOpenAdd] = useState(false);

//   const [alert, setAlert] = useState({
//   type: "",
//   message: "",
// });

  
//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   // const userId = localStorage.getItem("user_id");
//   const userId = "69579c6190a653b640e65639";

//   useEffect(() => {
//     if (selectedOrganizer) {
//       loadCategories(selectedOrganizer);
//     }
//   }, [selectedOrganizer]);

//   useEffect(() => {
//   const handleOrganizerChange = (e) => {
//     setSelectedOrganizer(e.detail);
//   };

//   window.addEventListener("companyChanged", handleOrganizerChange);
//   return () =>
//     window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);



//   // const defaultOrganizerId = companies?.[0]?._id;

//   // const defaultOrganizerId = "69410617a1c7c7664e634047";


//   // useEffect(() => {
//   //   if (defaultOrganizerId) {
//   //     loadCategories(defaultOrganizerId);
//   //   }
//   // }, [defaultOrganizerId]);

//   return (
//     <>
//       <div className="mb-4 flex justify-end">
//         <button
//           className="rounded bg-blue-600 px-4 py-2 text-white"
//           onClick={() => setOpenAdd(true)}
//         >
//           + Add Category
//         </button>
//       </div>

//       {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           onClose={() => setAlert({ type: "", message: "" })}
//           autoClose
//         />
//       )}

//       <ProductCategoryTable
//         data={data}
//         loading={loading}
//         onEdit={setEditing}
//         onDelete={async (row) => {
//           try {
//             const res = await deleteCategory(row._id, {
//               is_deleted: true,
//               deleted_by: userId || null,
//             });
//             setAlert({
//               type: "success",
//               message: res.data?.message || "Category deleted successfully",
//             });

//             loadCategories(selectedOrganizer);
//           } catch (error) {
//             setAlert({
//               type: "error",
//               message:
//                 error.response?.data?.message ||
//                 "Something went wrong while deleting category",
//             });
//           }
//         }}
//       />


//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <ProductCategoryModal
//           onClose={() => setOpenAdd(false)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("created_by", userId);

//               await addCategory(payload);

//               setOpenAdd(false);
//               loadCategories(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Something went wrong while creating category"
//               );
//             }
//           }}
//         />
//       </Modal>


      
//       <Modal open={!!editing} onClose={() => setEditing(null)}>
//         <ProductCategoryModal
//           initialData={editing}
//           onClose={() => setEditing(null)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("updated_by", userId);

//               await editCategory(editing._id, payload);

//               setEditing(null);
//               loadCategories(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Something went wrong while updating category"
//               );
//             }
//           }}
//         />
//       </Modal>


//     </>
//   );
// }
import { useEffect, useState, useCallback, useRef } from "react";
import { MdSearch, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import ProductCategoryTable from "./ProductCategoryTable";
import ProductCategoryModal from "./ProductCategoryModal";
import Modal from "components/common/Modal";
import { useProductCategory } from "./hooks/useProductCategory";
import Alert from "components/common/Alert";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";

export default function ProductCategoryContainer() {
  const {
    data,
    loading,
    paginationInfo,
    loadCategories,
    addCategory,
    editCategory,
    deleteCategory,
  } = useProductCategory();

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [alert, setAlert] = useState({
    type: "",
    message: "",
  });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = "69579c6190a653b640e65639";
  const abortControllerRef = useRef(null);

  // Debounce search input and reset page to 1
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  // Fetch API categories using page, limit, and debounced search
  const fetchData = useCallback(() => {
    if (!selectedOrganizer) return;

    loadCategories(selectedOrganizer, {
      page,
      limit,
      search: debouncedSearch,
    });
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };

    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const handleDeleteCategory = async (id) => {
    try {
      const res = await deleteCategory(id, {
        is_deleted: true,
        deleted_by: userId || null,
      });
      setAlert({
        type: "success",
        message: res?.message || "Category deleted successfully",
      });
      fetchData();
    } catch (error) {
      setAlert({
        type: "error",
        message:
          error.response?.data?.message ||
          "Something went wrong while deleting category",
      });
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search category..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Add Category"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => setOpenAdd(true)}
          />
        </div>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading categories...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <ProductCategoryTable
            data={data}
            onEdit={setEditing}
            onDelete={handleDeleteCategory}
          />

          {/* API-driven Pagination Bar */}
          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalCategories}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      {/* Add Category Modal */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)} title={"Create Product Category"}>
        <ProductCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);
              await addCategory(payload);
              setOpenAdd(false);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Something went wrong while creating category"
              );
            }
          }}
        />
      </Modal>

      {/* Edit Category Modal */}
      <Modal open={!!editing} onClose={() => setEditing(null)} 
     title= {"Edit Product Category"}>
        <ProductCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);
              await editCategory(editing._id, payload);
              setEditing(null);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Something went wrong while updating category"
              );
            }
          }}
        />
      </Modal>
    </TablePageLayout>
  );
}